(() => {
  const ARL = window.ARLISHCO;
  if (!ARL) return;

  function enhanceProductPage() {
    const main = document.querySelector('main[data-template="product"]');
    if (!main || main.querySelector('.arl-wishlist-toggle--product')) return;

    const handle = ARL.productHandleFromUrl(window.location.href);
    const titleBlock = main.querySelector('.product__info-container .product__title');
    if (!handle || !titleBlock) return;

    const title = (titleBlock.querySelector('h1')?.textContent || titleBlock.textContent || 'Product').trim();
    titleBlock.insertAdjacentElement('afterend', ARL.buildWishlistButton(handle, title, 'arl-wishlist-toggle--product'));
    ARL.updateWishlistInterface(main);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceProductPage, { once: true });
  } else {
    enhanceProductPage();
  }

  document.addEventListener('shopify:section:load', enhanceProductPage);
})();
